import { useNavigate } from 'react-router-dom';
import './cardIcon.css'
import { Iconify } from './iconify';

type datosIcono = {
  habilitar: boolean;
  enlace: string;
  backColor?: string;
  backColorDeshabilitar?: string;
  icon?: string;
  iconColor?: string;
  texto: string;
  imagen?: string | React.FC<React.SVGProps<SVGSVGElement>>;
};

export default function CardIcono(props: datosIcono) {
  const navigate = useNavigate();
  const goToNavigation = (site: string) => {
    navigate(site)
  }

  const renderIcono = () => {
    if (props.imagen) {
      if (typeof props.imagen === "string") {
        // Si es string → usar <img>
        return (
          <img src={props.imagen} alt="Campañas Section" style={{ width: '20px', height: 'auto' }} />
        );
      } else {
        const SvgIcon = props.imagen;
        return <SvgIcon style={{ width: "75px", height: "auto" }} />;
      }
    }
    return (
      <Iconify icon={props.icon || ""} width={75} sx={{ color: props.iconColor ? props.iconColor : 'white' }} />
    );
  };

  return (
    props.habilitar ?
      <div className='contenedor'>
        {/* <div className='imagen' onClick={() => redireccionar(props.enlace)} style={{background: props.backColor, borderRadius: '20px', height:225, width:225, display:'flex', justifyContent: 'center', alignItems: 'center' }}> */}
        <a onClick={() => goToNavigation(props.enlace)}>
          <div className='imagen' style={{ background: props.backColor, borderRadius: '20px', height: 225, width: 225, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div style={{ textAlign: 'center' }}>
              {renderIcono()}
              <p style={{ color: 'white', paddingTop: '15px' }} >{props.texto}</p>
            </div>
          </div>
        </a>
      </div>
      :
      <div>
        <div className='imagen' style={{ background: props.backColorDeshabilitar, borderRadius: '20px', height: 225, width: 225, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ textAlign: 'center' }}>
            {renderIcono()}
            <p style={{ color: 'white', paddingTop: '15px' }} >{props.texto}</p>
          </div>
        </div>
      </div>
  );
}